<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-leadlovers p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração LeadLovers
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://www.leadlovers.com/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça a LeadLovers
          </a>
        </small>
      </div>
      <hr />
      <form-group
        label="Token"
        id="token"
        v-model="form.token"
        :errors="errors.token"
        placeholder="Digite o Token da integração..."
      />
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <div class="d-flex justify-content-center pt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'bg-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["description", "status", "token"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    isValid() {
      return this.form.description && this.form.token;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.visible = false;
      this.clear();
    },
    submit() {
      this.loading = true;

      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("A integração foi salva!");
          this.$emit("update-list");
          this.onSubmit();
        })
        .catch(() => {
          this.$message.error("Erro ao salvar integração");
          this.onSubmit();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-leadlovers {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
